<template>
  <v-container fluid id="crm">
    <v-layout wrap>
      <v-flex xs12 sm4>
        <h3 class="title">{{ $t('Customer') }}</h3>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-right">
        <template v-if="loading">
          <v-btn outline loading color="grey"></v-btn>
          <v-btn outline loading color="grey"></v-btn>
        </template>
        <template v-else>
          <template v-if="$store.getters.getPackage != 'premium'">
            <v-btn color="grey" outline>
              <em class="fas fa-file-import" />
              &nbsp;
              {{ $t('Import') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
            <v-btn color="grey" outline>
              <em class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="grey" :disabled="delayImport" outline @click="importCustomer">
              <em class="fas fa-file-import" />
              &nbsp;
              {{ $t('Import') }}
            </v-btn>
            <v-btn color="grey" outline @click="exportCustomer">
              <em class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }}
            </v-btn>
          </template>
        </template>

        <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
          <v-icon>search</v-icon>
          &nbsp;
          {{ $t('advanced search') }}&nbsp;
          <em class="fas fa-angle-down" v-if="!showAdvance" />
          <em class="fas fa-angle-up" v-else />
        </v-btn>
      </v-flex>
    </v-layout>
    <div
      v-if="showAdvance"
      class="mb-4"
      style="border: 1px solid #eee; border-radius: 10px; position: relative"
    >
      <template>
        <v-premium-plan-popup
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium'"
          style="border-radius: 10px"
        ></v-premium-plan-popup>
        <filter-customer v-model="filter">
          <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn depressed @click="onSearch" color="primary">
            <em class="fas fa-search mr-1" />
            {{ $t('Search') }}
          </v-btn>
          <div
            slot="append"
            slot-scope="{ filter }"
            v-if="selectedBot.theme == 'universalutilities'"
          >
            <v-divider class="mt-2"></v-divider>
            <v-layout wrap>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('ชื่อจริง') }}</label>
                <input
                  type="text"
                  :placeholder="$t('ชื่อจริง')"
                  v-model="filter.uu_name"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for>{{ $t('ประปา') }}</label>
                <template v-if="selectedBot.theme == 'universalutilities'">
                  <div v-if="selectedBot.uu_areaname" class="primary--text">
                    {{ selectedBot.uu_areaname }}
                  </div>
                  <template v-else>
                    <multiselect
                      v-model="filter.uu_areaname"
                      :options="$store.state.uuAreaName"
                      selectLabel
                      selectedLabel
                      :searchable="false"
                      deselect-label
                    ></multiselect>
                  </template>
                </template>
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('DMA') }}</label>
                <input
                  type="text"
                  :placeholder="$t('DMA')"
                  v-model="filter.uu_dma"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex
                v-if="selectedBot.theme == 'universalutilities'"
                xs12
                sm4
                md4
                class="form-control pa-1"
              >
                <label>{{ $t('Register Status') }}</label>
                <div
                  class="form-inline form-control"
                  :class="{ 'has-error': errors.has('Context') }"
                >
                  <multiselect
                    v-model="filter.uu_register_status"
                    :options="['ลงทะเบียน', 'ไม่ลงทะเบียน']"
                    selectLabel
                    selectedLabel
                    deselect-label
                    :placeholder="$t('Register Status')"
                  ></multiselect>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </filter-customer>
      </template>
    </div>

    <p class="primary-color">{{ $t('total user') }} {{ estimate_user | numberFormat }}</p>
    <v-pagination
      :total-visible="15"
      v-model="pageNumber"
      @input="changePage"
      :length="pagelength"
    ></v-pagination>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="users"
      class="elevation-1"
      v-bind:pagination.sync="pagination"
      hide-actions
    >
      <template v-slot:items="props">
        <uu-customer-item v-model="props.item"></uu-customer-item>
      </template>

      <div class="text-xs-center" slot="no-data">{{ $t('No customer') }}</div>
    </v-data-table>
    <v-pagination
      :total-visible="15"
      v-model="pageNumber"
      @input="changePage"
      :length="pagelength"
    ></v-pagination>
  </v-container>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Multiselect from 'vue-multiselect'
import UuCustomerItem from './UuCustomerItem'
import { mapGetters } from 'vuex'
import FilterCustomer from '@/components/elements/FilterCustomer'

export default {
  data: function () {
    return {
      groupType: {},
      estimate_user: 0,
      pageNumber: 1,
      loadingEstimate: false,
      headers: [
        { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('ชื่อจริง'), value: 'uu_name' },
        // { text: this.$t('Channel'), value: 'app' },
        // { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('ประปา'), value: 'uu_areaname' },
        { text: this.$t('DMA'), value: 'uu_dma' },

        // { text: this.$t('Register Date'), value: 'registertimestamp' },
        // { text: this.$t('Last Active Date'), value: 'timestamp' },
        // { text: this.$t('Email'), value: 'email' },
        // { text: this.$t('phone no.'), value: 'phoneno' },
        // { text: this.$t('Status'), value: 'status' },
        // { text: this.$t('Message Sent'), value: 'messagesent' },
        // { text: this.$t('Locale'), value: 'locale' },
        { text: '', sortable: false }
      ],
      pagination: { rowsPerPage: -1 },
      tag: '',
      singleStatus: '',
      showAdvance: false,
      users: [],
      pagetmp: '',
      limit: 100,
      offset: 0,
      hasNext: true,
      count: 0,
      gendercount: '',
      users_count: [],
      delayImport: false,
      search: '',
      filter: {
        uu_register_status: '',
        uu_name: '',
        uu_areaname: '',
        uu_dma: '',
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: ''
      },
      loading: true,
      errorFilterTag: [],
      errorFilterStatus: [],
      customerfromfb: null
    }
  },
  components: {
    ScaleLoader,
    UuCustomerItem,
    PulseLoader,
    Multiselect,
    FilterCustomer
  },
  mounted: async function () {
    var vm = this

    vm.getLoadUsers().then(function (users) {
      vm.offset += vm.limit + 1
      vm.users = vm.users.concat(users)
    })

    vm.$store.dispatch('loadStatus')

    vm.$nextTick(function () {
      if (vm.selectedBot.theme == 'universalutilities') {
        vm.groupType = {
          label: this.$t('Customize'),
          value: 'customize'
        }
        vm.estimateReach(vm.groupType.value)
      } else {
        if (vm.groupType.value === 'customize') {
          if (vm.$store.getters.getPackage === 'premium') {
            vm.estimateReach(vm.groupType.value)
          } else {
            vm.estimateReach('')
          }
        } else {
          vm.estimateReach(vm.groupType.value)
        }
      }
    })
  },
  computed: {
    pagelength() {
      if (this.estimate_user) {
        return Math.ceil(this.estimate_user / 100)
      } else {
        return 1
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function (s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    }
  },
  methods: {
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * 100 - 100
        this.getMoreCustomers()
      }
    },
    estimateReach: function (type) {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }
      if (true) {
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            vm.filter.uu_areaname = vm.selectedBot.uu_areaname
          }
        }
        data.filter = vm.filter
        if (data.filter.uu_areaname == 'ทุกพื้นที่') {
          data.filter.uu_areaname = ''
        }
      } else {
        if (type === 'male') {
          Object.assign(data, { gender: 'male' })
        } else if (type === 'female') {
          Object.assign(data, { gender: 'female' })
        } else {
          Object.assign(data, { gender: 'all' })
        }
      }
      vm.loadingEstimate = true
      api.estimateReach(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.loadingEstimate = false
          return
        }
        if (response.data) {
          vm.estimate_user = response.data.count
        } else {
          vm.estimate_user = 0
        }
        vm.$nextTick(function () {
          vm.loadingEstimate = false
        })
      })
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function (newTags) {
      this.status = newTags
    },
    clearSearch: function () {
      this.filter = {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        status: ''
      }
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: function () {
      var vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        vm.offset = 0
        vm.hasNext = true
        vm.users = []
        vm.groupType = {
          label: this.$t('Customize'),
          value: 'customize'
        }
        this.estimateReach(vm.groupType)
        vm.getLoadUsers().then(
          function (users) {
            vm.offset += vm.limit + 1
            vm.users = vm.users.concat(users)
          },
          function (error) {}
        )
      })
    },
    getLoadUsers: function (isAll) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            vm.filter.uu_areaname = vm.selectedBot.uu_areaname
          }
        }
        let data = {
          pageid: vm.pageid,
          grouptype: vm.grouptype,
          filter: vm.filter
        }
        if (!isAll) {
          Object.assign(data, { limit: vm.limit, offset: vm.offset })
          // data.limit = vm.limit
          // data.offset = vm.offset
        }
        vm.loading = true
        api.getAllUsers(data, function (error, response) {
          if (error) {
            vm.loading = false
            reject(error)
          }
          if (vm.limit > response.data.length) {
            vm.hasNext = false
          } else {
            // response.data.pop()
          }

          var users = response.data

          // vm.count = response.count
          // vm.users_count.total = vm.count
          // vm.gendercount ="";
          // if(response.countmale!=null&&response.countfemale!=null){
          // 	vm.users_count.male = response.countmale
          // 	vm.users_count.female = response.countfemale
          // 	vm.gendercount =" (M:"+response.countmale+"/F:"+response.countfemale+")";

          // }

          vm.$nextTick(function () {
            vm.loading = false

            resolve(users)
          })
        })
      })
    },
    getMoreCustomers: function () {
      var vm = this
      vm.getLoadUsers().then(
        function (users) {
          vm.offset += vm.limit + 1
          vm.users = users
        },
        function (error) {}
      )
    },
    onFailLoad: function (index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    onActiveStartDate: function (value) {
      var vm = this
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function (value) {
      var vm = this
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    exportCustomer: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      vm.getLoadUsers(true).then(function (users) {
        csvContent +=
          'ลำดับที่สมัคร,รูป Profile,ชื่อ Line,ชื่อจริง,เบอร์โทร,ประปา,DMA,ที่อยู่,lat,long,เลขที่ผู้ใช้น้ำ,วันที่ Add เพื่อน'
        csvContent += '\r\n'
        let i = 1

        $.each(users, function (index, val) {
          let row = ''
          row += `" ${val.case} ",`
          row += '"' + (val.profile_pic ? val.profile_pic : '-') + '",'
          i++

          row +=
            '"' +
            (
              (val.first_name ? val.first_name : '') +
              ' ' +
              (val.last_name ? val.last_name : '')
            ).replace(/\r?\n|\r/g, ' / ') +
            '",'
          row += '"' + (val.uu_name ? val.uu_name : '-') + '",'
          row += `"="" ${val.phoneno ? val.phoneno : '-'} """,`
          row += '"' + (val.uu_areaname ? val.uu_areaname : '-') + '",'
          row += '"' + (val.uu_dma ? val.uu_dma : '-') + '",'
          row += '"' + (val.address ? val.address : '-') + '",'
          row += '"' + (val.uu_lat ? val.uu_lat : '-') + '",'
          row += '"' + (val.uu_long ? val.uu_long : '-') + '",'
          row += '"' + (val.uu_id ? val.uu_id : '-') + '",'
          row +=
            '"' +
            (val.registertimestamp
              ? moment(val.registertimestamp).format('DD/MM/YYYY HH:mm')
              : '-') +
            '",'

          csvContent += row + '\r\n'
        })

        vm.exportCsv(csvContent, 'customer')
      })
    },
    importCustomer: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to import customer?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: vm.selectedBot.pageid
            }
            vm.loading = true
            vm.offset = 0
            vm.hasNext = true
            vm.users = []
            api.insertUsersFromInbox(data, function (error, response) {
              if (error) {
                vm.loading = false
                return
              }
              vm.getLoadUsers().then(
                function (users) {
                  vm.users = vm.users.concat(users)

                  vm.delayImport = true
                  vm.$swal.fire({
                    title: vm.$t('Import customer successful'),
                    type: 'success',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true
                  })
                },
                function (error) {}
              )
            })
          }
        })
    }
  },
  watch: {
    count: function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$emit('onUserLoaded', vm.count)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/uu/UuCustomers.vue